import PropTypes from "prop-types";

import { Container, Number, Arrow, NumberContainer } from "./Pagination.styled";

function Pagination({
    amountOfItems,
    perPage,
    currentPageIndex,
    setCurrentPageIndex
}) {
    const pages = Math.ceil(amountOfItems / perPage);

    const forwardNavigationPossible = currentPageIndex !== pages - 1;
    const backwardNavigationPossible = currentPageIndex !== 0;

    function navigateToPreviousPage() {
        if (backwardNavigationPossible) {
            setCurrentPageIndex(currentPageIndex - 1);
        }
    }

    function navigateToNextPage() {
        if (forwardNavigationPossible) {
            setCurrentPageIndex(currentPageIndex + 1);
        }
    }

    return (
        <Container>
            <Arrow
                src="/images/icon-arrow-long-left.svg"
                alt="Vorige"
                loading="lazy"
                width={24}
                height={24}
                onClick={() => navigateToPreviousPage()}
                disabled={!backwardNavigationPossible}
            />
            <NumberContainer>
                {[...Array(pages)].map((_, index) => (
                    <Number
                        active={index === currentPageIndex}
                        onClick={() => setCurrentPageIndex(index)}
                    >
                        {index + 1}
                    </Number>
                ))}
            </NumberContainer>
            <Arrow
                src="/images/icon-arrow-long-right.svg"
                alt="Vorige"
                loading="lazy"
                width={24}
                height={24}
                onClick={() => navigateToNextPage()}
                disabled={!forwardNavigationPossible}
            />
        </Container>
    );
}

Pagination.propTypes = {
    amountOfItems: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    currentPageIndex: PropTypes.number.isRequired,
    setCurrentPageIndex: PropTypes.func.isRequired
};

export default Pagination;
